<template>
  <div class="rule-digital-sort">
    <div class="rule-digital-sort-btn">
      <el-button class="eb-button-orange eb-button-big" @click="restoreDigitalSort()">还原排序</el-button>
      <el-button class="eb-button-orange eb-button-big" @click="saveDigitalSortResult()">保存排序结果</el-button>
    </div>
    <draggable v-model="ruleListSort" class="rule-type-sort" :options="{handle: '.rule-type-sort-item-title'}" @end="onRuleTypeEnd">
      <div class="rule-type-sort-item" v-for="(item, $typeIndex) in ruleListSort" :key="$typeIndex">
        <div class="rule-type-sort-item-title">
          <i class="el-icon-document"></i> {{ $typeIndex+1 }} {{ item.ruleType }}</div>
        <draggable class="rule-type-digital-items" v-model="item.ruleItem" :options="{group: 'ruleDigital', handle: '.rule-type-digital-item'}"
          element="ul" @end="onRuleDigitalEnd">
          <li class="rule-type-digital-item" v-for="(digitalItem, $digitalIndex) in item.ruleItem" :key="digitalItem.digitalId">
            <i class="el-icon-sort"></i> {{ $typeIndex+1 }}.{{ $digitalIndex+1 }} {{ digitalItem.ruleName }}
          </li>
          <!-- v-if="item.ruleItem.length == 0" -->
          <li style="height:0px;border-bottom:0px;">&nbsp;</li>
        </draggable>
      </div>
    </draggable>
  </div>
</template>
<script>
import EventBus from '@/plugins/event-bus';
import { cloneDeep, padStart } from 'lodash';
import { sortRuleDigital } from '@/services/rule/rule-digital-service';

export default {
  name: '',
  components: {},
  filters: {},
  props: {
    ruleList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      ruleListSort: []
    };
  },
  computed: {},
  watch: {
    // ruleList(newVal) {
    //   this.ruleListSort = cloneDeep(this.ruleList);
    // }
  },
  created() {
    EventBus.$on('initRuleDigitalSortList', async (params, done) => {
      this.initRuleDigitalSortList();
    });
  },
  mounted() {},
  methods: {
    initRuleDigitalSortList() {
      this.ruleListSort = cloneDeep(this.ruleList);
    },
    onRuleTypeEnd(evt) {
    },
    onRuleDigitalEnd(evt) {
    },
    restoreDigitalSort() {
      this.ruleListSort = cloneDeep(this.ruleList);
    },
    getSortedRuleList() {
      let typeGroupSortObj = {};
      let resultList = [];
      this.ruleListSort.forEach((typeItem, typeIndex) => {
        let padTypeIdx = '1' + padStart(typeIndex + 1, 3, '0');

        typeGroupSortObj[typeItem.ruleType] = padTypeIdx;

        typeItem.ruleItem.forEach((item, index) => {
          let tmp = {};
          let padIdx = '1' + padStart(index + 1, 4, '0');
          if (
            item.typeName !== typeItem.ruleType ||
            item.groupSort !== typeGroupSortObj[item.typeName] ||
            item.sortIndex !== padIdx
          ) {
            tmp.digitalId = item.digitalId;
            tmp.typeName = typeItem.ruleType;
            tmp.groupSort = typeGroupSortObj[typeItem.ruleType];
            tmp.sortIndex = padIdx;
            resultList.push(tmp);
          }
        });
      });
      return resultList;
    },
    async saveDigitalSortResult() {
      let sortedRuleList = this.getSortedRuleList();
      if (sortedRuleList.length === 0) {
        this.$message.info('排序未发生变动，无需保存');
        return;
      }
      try {
        let params = {
          sortedRuleList: JSON.stringify(sortedRuleList)
        };
        let { data } = await sortRuleDigital(params);
        if (data.returnCode === '01') {
          this.$message.success('规则排序成功！');
          EventBus.$emit('reloadRuleDigitalList');
          this.dialogVisible = false;
        } else if (data.returnCode === '03') {
          this.$message.error('缺少参数');
        } else {
          this.$message.error('规则排序失败！');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    }
  },
  beforeDestroy() {
    EventBus.$off('initRuleDigitalSortList');
  }
};
</script>
<style lang="less">
.rule-digital-sort {
  // border: 1px solid red;
  .rule-digital-sort-btn {
    height: 50px;
    line-height: 50px;
  }
  .rule-type-sort {
    display: table;
    table-layout: fixed;
    width: 100%;
    border: 1px solid #cccccc;
    .rule-type-sort-item {
      display: table-cell;
      padding: 10px;
      border-right: 1px solid #cccccc;
      height: 300px;
      & > .rule-type-sort-item-title {
        // border: 1px solid blue;
        cursor: move;
        background-color: #cccccc;
        height: 40px;
        line-height: 40px;
        // padding-left: 1em;
        text-indent: 0.5em;
        width: 100%;
        float: left;
      }
      .rule-type-digital-items {
        margin: 0px;
        padding-top: 40px;
        padding-left: 0px;
        border: 1px solid #cccccc;
        border-radius: 2px;
        list-style: none;
        height: 100%;
        & > li {
          text-indent: 0.5em;
          height: 35px;
          line-height: 35px;
          border-bottom: 1px solid #cccccc;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: move;
        }
      }
    }
  }
}
</style>
